// Environment variables with type safety
export const env = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL || 'https://backend.digitalrepublic.space',
  apiVersion: import.meta.env.VITE_API_VERSION || 'api/v1',
  wsUrl: import.meta.env.VITE_WS_URL || 'wss://backend.digitalrepublic.space',

  // External Services
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN || '',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY || '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
  // Exclude admin ("staff") users from analytics entirely
  posthogExcludeStaff: import.meta.env.VITE_POSTHOG_EXCLUDE_STAFF === 'true',
  // Session replay on unless explicitly disabled
  posthogSessionReplay: import.meta.env.VITE_POSTHOG_SESSION_REPLAY !== 'false',

  // Sentry (error tracking + performance tracing) — inert without a DSN
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
  sentryTracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '') || 0.2,

  // App Configuration
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Feature Flags
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableWebSocket: import.meta.env.VITE_ENABLE_WEBSOCKET !== 'false', // enabled by default

  // App Info
  appName: 'Asogro',
  appVersion: '1.0.0',
} as const;

// Validate required environment variables
export const validateEnv = () => {
  const required = ['VITE_API_URL'];
  const missing = required.filter((key) => !import.meta.env[key]);

  if (missing.length > 0) {
    console.warn(`Missing environment variables: ${missing.join(', ')}`);
  }
};

// Type for environment configuration
export type EnvConfig = typeof env;
